export default __webpack_public_path__ + "static/media/ring.dbcdb192.webp";